import React from "react";
import "../_qokr-forms.scss";
import "./_qokr-rows-field.scss";

// An editable numbered list of statements (key results / initiatives) with
// add and remove — the live-review and tracking editors. Rows keep their BE
// id (`rowsFrom` / `toRows`) so kept rows keep their progress (§11).

export const rowsFrom = (items = [], idKey) =>
  items.map((item) => ({ id: item[idKey] || null, statement: item.statement }));

export const toRows = (rows, idKey) =>
  rows
    .filter((row) => row.statement.trim())
    .map((row) => ({
      ...(row.id ? { [idKey]: row.id } : {}),
      statement: row.statement.trim(),
    }));

// `min` / `max` (2026-10-21): the bin is disabled at `min` rows and Add at
// `max`, each saying why — the caller still validates FILLED rows on save.
const QokrRowsField = ({
  label,
  rows,
  min = 0,
  max,
  maxChars,
  placeholder,
  onChange,
}) => (
  <div className="qokr-rows-field__field">
    <span className="qokr-rows-field__label">{label}</span>
    {rows.map((row, index) => (
      <div className="qokr-rows-field__row" key={index}>
        <span className="qokr-rows-field__seq">{index + 1}</span>
        <input
          className="qokr-textarea"
          value={row.statement}
          maxLength={maxChars}
          placeholder={placeholder}
          aria-label={`${label} ${index + 1}`}
          onChange={(event) =>
            onChange(
              rows.map((r, i) =>
                i === index ? { ...r, statement: event.target.value } : r,
              ),
            )
          }
        />
        <button
          type="button"
          className="qokr-rows-field__remove"
          aria-label={`Remove ${label.toLowerCase()} ${index + 1}`}
          disabled={rows.length <= min}
          title={
            rows.length <= min
              ? `At least ${min} ${label.toLowerCase()} needed`
              : undefined
          }
          onClick={() => onChange(rows.filter((_, i) => i !== index))}
        >
          <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
      </div>
    ))}
    {rows.length < max ? (
      <button
        type="button"
        className="qokr-text-btn"
        onClick={() => onChange([...rows, { id: null, statement: "" }])}
      >
        <i className="fa-solid fa-plus" aria-hidden="true" />
        Add
      </button>
    ) : (
      <span className="qokr-rows-field__limit">
        Up to {max} {label.toLowerCase()}
      </span>
    )}
  </div>
);

export default QokrRowsField;
